import axios, { HttpStatusCode } from 'axios';
import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { logger } from '@trading-utils/logger';
import { getAuthToken } from '@trading-utils/sso-cognito';

import { apiRoutes } from '../../config/apiRoutes';
import { appRoutes } from '../../config/appRoutes';
import useAppStore from '../../store/app.store';

export default function AxiosWrapper({ children }: PropsWithChildren) {
  const navigate = useNavigate();
  const { ERROR_401, ERROR_403 } = appRoutes;

  axios.interceptors.request.use(async (config) => {
    if (config?.url?.startsWith(`${apiRoutes.base}`)) {
      try {
        const token = await getAuthToken();
        if (token) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `Bearer ${token}`;
        }

        // Add X-Active-Company-Id header if user has a company
        const user = useAppStore.getState().user;
        const activeCompanyId = user?.companies?.[0]?.companyId;
        if (activeCompanyId) {
          // eslint-disable-next-line no-param-reassign
          config.headers['X-Active-Company-Id'] = activeCompanyId;
        }
      } catch (error) {
        logger.error('Error getting auth token', { error });
      }
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        if (!window.location.href.includes(ERROR_401) && !window.location.href.includes(ERROR_403)) {
          switch (error.response.status) {
            case HttpStatusCode.Unauthorized:
              navigate(ERROR_401);
              break;
            case HttpStatusCode.Forbidden:
              navigate(ERROR_403);
              break;
            case HttpStatusCode.MethodNotAllowed:
              break;
            default:
              break;
          }
        }
      }
      return Promise.reject(error);
    }
  );
  return children;
}
